const getDiscordLoginLink = () => {
    let discordLink;
    const currentUrl = window.location.hostname

    switch (currentUrl) {
      case 'www.fibergamingnetwork.com':
        discordLink = 'https://discord.com/api/oauth2/authorize?client_id=1095054196732067841&redirect_uri=https%3A%2F%2Fwww.fibergamingnetwork.com%2Fdiscord&response_type=token&scope=identify%20guilds.join'
        break;
      case 'beta.fibergamingnetwork.com':
        discordLink = 'https://discord.com/api/oauth2/authorize?client_id=1095054196732067841&redirect_uri=https%3A%2F%2Fbeta.fibergamingnetwork.com%2Fdiscord&response_type=token&scope=identify%20guilds.join'
        break;
      case 'fibergamingnetwork.com':
        discordLink = 'https://discord.com/api/oauth2/authorize?client_id=1095054196732067841&redirect_uri=https%3A%2F%2Ffibergamingnetwork.com%2Fdiscord&response_type=token&scope=identify%20guilds.join'
        break;
      case 'localhost':
        discordLink = 'https://discord.com/api/oauth2/authorize?client_id=1095054196732067841&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fdiscord&response_type=token&scope=identify%20guilds.join'
        break;
    }

    return discordLink
  }

export default getDiscordLoginLink;